<template>
  <div
    class="vb-div"
    :class="{ selected: selectedPath == path }"
    :draggable="selectedPath == path"
    @scroll="$emit('scroll', $event)"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
    v-if="!!components && !!components.length"
  >
    <component
      v-for="(component, key) in components"
      :is="`vb-${component.type}`"
      :key="`div-${key}`"
      :data="component"
      :path="`${path}-${key}`"
      :components="component.type != 'div-vertical' ? undefined : component.components"
      :draggable="selectedPath == `${path}-${key}`"
      :selectedPath="selectedPath"
      @update="$emit('update')"
      @select="p => $emit('select', p)"
      @toDrag="p => $emit('toDrag', p)"
      @toDrop="p => $emit('toDrop', p)"
      @answer="payload => $emit('answer', payload)"
    />
  </div>
  <div
    class="vb-div-empty"
    :class="{ selected: selectedPath == path }"
    :draggable="data && data.type != 'page' && selectedPath == path"
    @scroll="$emit('scroll', path)"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
    v-else
  >
    Div
  </div>
</template>
<script>
  import VBExerciseSelect from './VirtualBookExerciseSelect'
  import VBExerciseWrite from './VirtualBookExerciseWrite'
  import VBExerciseComplete from './VirtualBookExerciseComplete'
  import VBImg from './VirtualBookImage'
  import VBAudio from './VirtualBookAudio'
  import VBDivVertical from './VirtualBookDivVertical'

  export default {
    name: 'vb-div',
    components: {
      [VBExerciseSelect.name]: VBExerciseSelect,
      [VBExerciseWrite.name]: VBExerciseWrite,
      [VBExerciseComplete.name]: VBExerciseComplete,
      [VBImg.name]: VBImg,
      [VBAudio.name]: VBAudio,
      [VBDivVertical.name]: VBDivVertical
    },
    props: {
      components: {
        required: true
      },
      data: {
        required: true
      },
      path: {
        required: true
      },
      selectedPath: {
        type: String
      }
    },
  }
</script>
<style lang="scss" scoped>
  .vb-div {
    display: grid;
    flex-grow: 1;
    grid-template-columns: 1fr 1fr;

    &.selected {
      border: .2rem dashed red;
    }

    *:first-child {
      padding-right: 5px;
    }

    *:not(:first-child) {
      padding-left: 5px;
    }
  }

  .vb-div-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    margin: .5rem;
    height: 4rem;
    border: .2rem dashed brown;

    &.selected {
      border: .2rem dashed red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VirtualBookViewer/VirtualBookDiv.vue